module.exports = __webpack_public_path__ + "img/hr-level2addon_idle_gun_shadow.5949f87e.png";